import { useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useTeam } from '../../hooks/useTeam';

/**
 * Allows team workspace routes only when the user owns a team or is an active member.
 * Used under `/team/workspace/*`.
 */
const TeamWorkspaceGate = () => {
  const { userTeams, activeTeamId, loading, reconcileActiveTeam } = useTeam();

  const allowedTeamIds = new Set(userTeams.map((team) => team.id));
  const hasInvalidActiveTeam =
    !!activeTeamId && !allowedTeamIds.has(activeTeamId);

  useEffect(() => {
    if (!hasInvalidActiveTeam) return;
    reconcileActiveTeam({ redirectIfMissing: true });
  }, [hasInvalidActiveTeam, reconcileActiveTeam]);

  if (hasInvalidActiveTeam) {
    return <Navigate to="/team" replace />;
  }

  if (loading) {
    return (
      <div className="min-h-[40vh] flex items-center justify-center font-body">
        <div className="w-12 h-12 border-4 border-herbal-green border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (userTeams.length === 0) {
    return <Navigate to="/team" replace />;
  }

  return <Outlet />;
};

export default TeamWorkspaceGate;
